/* ============================================
   BYTE.JS - Custom JavaScript
   ============================================ */

/**
 * Login page: tabs (Müşteri / Bayi) – active state, kayıt linki ve prompt metni
 */
function initLoginTabs() {
  const tabs = document.querySelector('[data-login-tabs]');
  const createAccountLink = document.querySelector('[data-create-account-link]');
  const createAccountPrompt = document.querySelector('[data-create-account-prompt]');
  const registerUrl = createAccountLink ? createAccountLink.getAttribute('data-register-url') : '';
  const b2bRegisterUrl = '/pages/b2b-kayit';
  const promptCustomer = 'Hesabınız yok mu?';
  const promptBayi = 'Bayi hesabınız yok mu?';

  function getIsB2b() {
    const activeTab = tabs && tabs.querySelector('[data-login-tab].is-active');
    return activeTab && activeTab.getAttribute('data-tab-type') === 'b2b';
  }

  function updateCreateAccountHref() {
    if (!createAccountLink) return;
    createAccountLink.href = getIsB2b() ? b2bRegisterUrl : registerUrl;
  }

  function updateCreateAccountPrompt() {
    if (!createAccountPrompt) return;
    createAccountPrompt.textContent = getIsB2b() ? promptBayi : promptCustomer;
  }

  function setActiveTab(tabEl) {
    if (!tabs || !tabEl) return;
    tabs.querySelectorAll('[data-login-tab]').forEach(function (t) {
      t.classList.remove('is-active');
      t.setAttribute('aria-selected', 'false');
    });
    tabEl.classList.add('is-active');
    tabEl.setAttribute('aria-selected', 'true');
    updateCreateAccountHref();
    updateCreateAccountPrompt();
  }

  if (tabs) {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('tab') === 'bayi') {
      const bayiTab = tabs.querySelector('[data-login-tab][data-tab-type="b2b"]');
      if (bayiTab) setActiveTab(bayiTab);
    }

    tabs.addEventListener('click', function (e) {
      const tab = e.target.closest('[data-login-tab]');
      if (!tab) return;
      setActiveTab(tab);
    });
  }

  updateCreateAccountHref();
  updateCreateAccountPrompt();
}

document.addEventListener('DOMContentLoaded', initLoginTabs);
